import { AfterViewInit, Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/demo/shared/shared.module';
import { catchError, map, of, startWith, Subject, switchMap, takeUntil } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { BaseService } from 'src/app/tabms/services/base/base.service';
import { ThemeLayoutService } from 'src/app/@theme/services/theme-layout.service';
import { RTL } from 'src/app/@theme/const';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { searchSqlDto } from 'src/app/tabms/models/base/base';

@Component({
  selector: 'app-pop-up-search',
  standalone: true,
  imports: [CommonModule, SharedModule],
  templateUrl: './pop-up-search.component.html',
  styleUrl: './pop-up-search.component.scss'
})
export class PopUpSearchComponent implements OnDestroy, OnInit, AfterViewInit {

  dataSource
  displayedColumns: string[] = []
  totalcount
  serviceInstance
  currentLang
  selectedColumn: string = '';
  filterValues: any = {};
  operators = [{ code: 0, name: 'contains' },
  { code: 1, name: 'equals' },
  { code: 2, name: 'not equals' },
  { code: 3, name: 'starts with' },
  { code: 4, name: 'ends with' }];
  selectedOperator = 0;
  searchForm: FormGroup
  searchData: searchSqlDto
  fieldHasSqlQueryId: string
  pageNumber
  visiableColumns : string[] = []


  private destroy: Subject<void> = new Subject<void>();

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  // readonly dialogRef = inject(MatDialogRef<PopUpSearchComponent>);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private baseService: BaseService,
    private themeLayoutService: ThemeLayoutService,
    private dialogRef: MatDialogRef<PopUpSearchComponent>,
    private fb: FormBuilder
  ) {

    this.currentLang = this.baseService.getCurrentLanguage();
    this.searchForm = this.fb.group({
      search: new FormControl('')
    })

    this.dataSource = new MatTableDataSource<any[]>;

    this.serviceInstance = this.data.service
    this.fieldHasSqlQueryId = this.data.fieldDictionaryId

    this.themeLayoutService.directionChange.subscribe({
      next: (dir) => {
        (dir === RTL) ? (this.currentLang = 'ar') : (this.currentLang = 'en');
      }
    })

  }

  ngOnInit() {
    this.searchData = {
      fielddictionaryid: this.fieldHasSqlQueryId,
      columnssearch: {},
      searchinallcolumns: '',
      searchoperator: this.selectedOperator,
      skip: 0,
      take: 10,
      orderby: '',
      descending: true
    }
    console.log('searchData', this.searchData)

    // this.dataSource.filterPredicate = (data: any, filter: string) => {
    //   const filters = JSON.parse(filter); // استرجاع القيم المدخلة
    //   return Object.keys(filters).every(column => {
    //     if (!filters[column]) return true; // إذا لم يتم إدخال قيمة لهذا العمود، تخطيه
    //     return data[column]?.toString().toLowerCase().includes(filters[column]);
    //   });
    // };

  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;

    this.getDialogData();
  }

  getDialogData$(skip, take) {
    this.searchData = { ...this.searchData, skip, take }
    return this.serviceInstance.getDataBySqlQuery(this.searchData)
  }

  getDialogData() {
    this.paginator.page.pipe(startWith({}), switchMap(() => {
      return this.getDialogData$((this.paginator.pageIndex) * this.paginator.pageSize, this.paginator.pageSize).pipe(catchError(() => of(null)));
    }), map((res: any) => {
      if (res == null) return [];
      return res;
    }), takeUntil(this.destroy)).subscribe({
      next: (res) => {
        console.log('getDialogData', res);
        const data = res.result.data || []
        this.dataSource = new MatTableDataSource(data);
        this.displayedColumns = data ? Object.keys(res.result.data[0]): [];
        console.log('displayedColumns', this.displayedColumns)
        this.visiableColumns = this.displayedColumns.filter(col => col !== 'id');
        this.visiableColumns.push('actions');
        this.totalcount = res.result.totalcount;
      }

    })
  }

  //select item
  selectedItem(row: {}) {
    let firstItem = Object.values(row)[0]
    console.log('selectedItem', firstItem, row)

    const key = this.displayedColumns[0];

    this.dialogRef.close({[key]: firstItem});
  }

  // filter 
  applyFilter(event: Event, column: string) {
    const filterValue = (event.target as HTMLInputElement).value;
    console.log(filterValue, column);

    this.filterValues[column] = filterValue; // Add the filter value to the filterValues object

    this.searchData = { ...this.searchData, columnssearch: this.filterValues, searchoperator: this.selectedOperator }
    this.getDialogData();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  search() {
    console.log('search', this.searchForm.value);
    // const filterValue = { 'searchInAllColumns': this.searchForm.value.search, operator: this.selectedOperator };
    this.searchData = { ...this.searchData, searchinallcolumns: this.searchForm.value.search, searchoperator: this.selectedOperator }

    console.log('search', this.searchData);
    // this.dataSource.filter = JSON.stringify(this.searchData );
    this.getDialogData();
    // debugger
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }

  }

  //region destory subscribtion
  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }
  //end region
}
